/* VersaButton object proxy.
10/21/2020 Created RLB

//// markers show disabled safeStageSymbol and replaced with stageSymbol 4/6/24

/*
Properties and methods:
selectable	boolean			True: Enables toggling
							False: Does not toggle. Always shows UnselectedUp or UnselectedDown 
selected	boolean			Sets & gets toggling state
buttonEnabled	boolean		Plays Disabled frame and does not respond to mouse
rolloverText	string		Text to appear in rollover text area
hasRolloverText
enableRolloverText
hasControlledFaceText		true: script will shift face_txt on button down

Throws events on window:
BUTTON_DOWN
BUTTON_UP
BUTTON_CLICKED

Alternatively, you can set callback functions like this:
        this.exampleButton_p.onButtonClick( (e) => {
            this.doClickExample("Clicked.");
        })
        this.exampleButton_p.onButtonDown( (e) => {
            this.doClickExample("Down.");
        })    
        this.exampleButton_p.onButtonUp( (e) => {
            this.doClickExample("Up.");
        })    
Note if you set a callback function, the window event will NOT be thrown.
If you want to change back to window events, set the calback function to Null.

Event syntax:
	eventUtils2.addListener(iGroup, xxxxx_btn, "BUTTON_CLICKED", buttonClickHandler);
	buttonClickHandler(e:CustomEvent)
		e.target.name will be a string containing the symbol name of the button
	
	
Button states:
You must edit the timeline graphics for so that the appearance is what you want in each of these states.
Unselected up
Unselected over
Unselected down
Selected up
Selected down
Selected over	
Disabled	


*/
import AnimateProxyBase from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-proxy-base";
import AnimateButtonProxy from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-button-proxy";
import TimingInfo from "SATPROF_LIBRARY/DropinSupervisor/timing-info";
import AnimateRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/animate-render-space";
import UtilSP from "SATPROF_UTILS/UtilSP"; 
import { StringKeyframeTrack, AudioAnalyser } from "three";

export default class VersaButton extends AnimateProxyBase{
 
    private animateSpace:AnimateRenderSpace
    //private universal_rs:UniversalRenderSpace;
    private mystage:any;	private ready:boolean = false;
	private _selected:boolean = false;
	private _selectable:boolean = false;
	private _buttonEnabled:boolean = true;
	private _buttonIsDown:boolean = false;
    public myStageName:string;
    public myStagePath:string;	// Settable properties:
	public name:string;
    protected _onClickCallback : (e: MouseEvent) =>void = null;
    protected _onMousedownCallback : (e: MouseEvent) =>void = null;
    protected _onMouseupCallback : (e: MouseEvent) =>void = null;
	private _hasFaceText:boolean = false; //default;
	private _faceTextDownShiftX:number = 2;
	private _faceTextDownShiftY:number = 2;
	private _faceTextX0:number = 0;
	private _faceTextY0:number = 0;
	private _hasRolloverText:boolean = false; //default;
	private _enableRolloverText:boolean = true; //default;
	

    onFrameZero(){
        //console.log("In VersaButton.onFrameZero()");
        super.onFrameZero();
       	this.animateSpace = this.extraData.animateSpace;
       // this.universal_rs = this.extraData.universal_rs;
        this.mystage = this.extraData.mystage;
        this.myStageName = this.extraData.stageName;
        this.myStagePath = this.extraData.parentStageName + "."+this.extraData.stageName;
        //console.log("In VersaButton_p.onFrameZero(), this.myStagePath = "+this.myStagePath);
        this.initialize();

    }
	public initialize(){

		//this.buttonMode = true;
		//this.useHandCursor = true;
		if (this._hasRolloverText){
			////this.safeStageSymbol.rollover_txt.visible = false;
			this.stageSymbol.rollover_txt.visible = false;
		} else {
			//console.log("ERROR in VersaButton.ts: rollover_txt does not exist. name = "+this.myStageName);
		}
		this.stageSymbol.mouseChildren = false;

        this.stageSymbol.addEventListener( "mousedown", this.mouseDown.bind(this) );
        this.stageSymbol.addEventListener( "pressup", this.mouseUpOutside.bind(this) );
        this.stageSymbol.addEventListener( "click", this.clickHandler.bind(this) );
        this.stageSymbol.addEventListener( "mouseover", this.mouseOver.bind(this) );
        this.stageSymbol.addEventListener( "mouseout", this.mouseOut.bind(this) );
		//document.addEventListener( "click", this.onDocumentClicked.bind(this) );   	// Any click anywhere

		this.ready = true;
    }  
    onRequestAnimFrame(timingInfo : TimingInfo) {
        // Do every frame
	}  
    public onButtonDown(eventCallback : (e:MouseEvent)=>void ){
        // Allows external function to store a callback function for later use.
        // Define _onPressCallback to be whatever the external function wants saved.
        this._onMousedownCallback = eventCallback;
    }
    public onButtonClick(eventCallback : (e:MouseEvent)=>void ){
        // Allows external function to store a callback function for later use.
        // Define _onPressCallback to be whatever the external function wants saved.
        this._onClickCallback = eventCallback;
    }
    public onButtonUp(eventCallback : (e:MouseEvent)=>void ){
        // Allows external function to store a callback function for later use.
        // Define _onPressCallback to be whatever the external function wants saved.
        this._onMouseupCallback = eventCallback;
    }				
	public mouseDown(e:MouseEvent){
		//trace("Mouse down");
		if (!this._buttonEnabled){
			return;
		}
		if (this._hasFaceText){
			this.stageSymbol.face_txt.x = this._faceTextX0 + this._faceTextDownShiftX;
			this.stageSymbol.face_txt.y = this._faceTextY0 + this._faceTextDownShiftY;
		}

		if (this._selectable){
			if (this._selected){
				this.stageSymbol.gotoAndPlay("SelectedDown");
			} else {
				this.stageSymbol.gotoAndPlay("UnselectedDown");
			}
		} else {
				this.stageSymbol.gotoAndPlay("UnselectedDown");
		}
		this._buttonIsDown = true;
		if (this._onMousedownCallback) {
            // A callback function exists; it must have been stored by an external function 
            // Run that callback function:
            this._onMousedownCallback(e);
		} else {
			// If no callback function has been set, then throw an event on window.
			const event = new CustomEvent('BUTTON_DOWN', { detail:{name:this.name} });
			window.dispatchEvent(event)	
		}	
	}
	public clickHandler(e:MouseEvent){
		//trace("Mouse up in button");
		if (!this._buttonEnabled){
			return;
		}
		if (this._selectable){
			this._selected = !this._selected;
		}
		this.returnToUp();
		// This is a click
		//this.dispatchEvent(new CustomEvent("BUTTON_CLICKED",false,false,this.name,"clickedOnAButton"));
		if(this._onClickCallback){
            // A callback function exists; it must have been stored by an external function 
            // Run that callback function:
            this._onClickCallback(e);		
		}else {
			const event = new CustomEvent('BUTTON_CLICKED', { detail:{name:this.name} });
			window.dispatchEvent(event)
		}

	}
	public mouseUpOutside(e:MouseEvent){
		//console.log("Mouse up outside");
		this.doMouseOut(e);
		this.returnToUp();
	}
	public mouseOut(e:MouseEvent){
		//console.log("Mouse out");
		this.doMouseOut(e);
		this.returnToUp();
	}
	private doMouseOut(e:MouseEvent){

		if (this._buttonIsDown){
			if(this._onMouseupCallback){
            	// A callback function exists; it must have been stored by an external function 
            	// Run that callback function:
            	this._onMouseupCallback(e);		
			} else {
				const event = new CustomEvent('BUTTON_UP', { detail:{name:this.name} });
				window.dispatchEvent(event);			
			}	
		}	
		this._buttonIsDown = false;

	} 
	public mouseOver(e:MouseEvent){
		//console.log("In VersaButton_p mouseOver");
		if (!this._buttonEnabled){
			return;
		}
		if (this._selectable){
			if (this._selected){
				this.stageSymbol.gotoAndPlay("SelectedOver");
			} else {
				this.stageSymbol.gotoAndPlay("UnselectedOver");
			}
		} else {
				this.stageSymbol.gotoAndPlay("UnselectedOver");
		}
		if (this._hasRolloverText && this.enableRolloverText){
			////this.safeStageSymbol.rollover_txt.visible = true;
			this.stageSymbol.rollover_txt.visible = true;
			//console.log("In VersaButton_p mouseOver visible = true");

		}
	}

	private returnToUp(){
		//if (this._selectable){
			if (this._selected){
				this.stageSymbol.gotoAndPlay("SelectedUp");
			} else {
				this.stageSymbol.gotoAndPlay("UnselectedUp");
			}
		//} else {
			//this.stageSymbol.gotoAndPlay("UnselectedUp");
		//}
		if (this._hasFaceText){
			this.stageSymbol.face_txt.x = this._faceTextX0;
			this.stageSymbol.face_txt.y = this._faceTextY0;
		}
		if (this._hasRolloverText){
			////this.safeStageSymbol.rollover_txt.visible = false;
			this.stageSymbol.rollover_txt.visible = false;
		}
		if (this._buttonEnabled){
			this.stageSymbol.alpha = 1;
			//this.useHandCursor = true;
		} else {
			try {
				this.stageSymbol.gotoAndPlay("Disabled");
				//this.useHandCursor = false;
				//trace("Did go to and play Disabled");
			} catch (error){
				this.stageSymbol.alpha = 0.3;
				//this.useHandCursor = false;
				//trace("Error - could not go to and play Disabled");
			}
		}
	
	}
	public set selectable(val:boolean){
		if (val != this.selectable){
			this._selectable = val;
			this.returnToUp();
		}
	}
	public get selectable():boolean{
		return this._selectable;
	}
	public set selected(val:boolean){
		if (val != this._selected){
			this._selected = val;
			this.returnToUp();
		}
	}
	public get selected():boolean{
		return this._selected;
	}
	
	public set hasFaceText(val:boolean){
		this._hasFaceText = val;
		if (this._hasFaceText){
			this._faceTextX0 = this.stageSymbol.face_txt.x;
			this._faceTextY0 = this.stageSymbol.face_txt.y;
		}
	}
	public get hasFaceText(){
		return this._hasFaceText;
	}
	public set faceText(val:string){
		if (this._hasFaceText){
			this.stageSymbol.face_txt.text = val;
		}
	}	
	public get faceText(){
		if (this._hasFaceText){
			return this.stageSymbol.face_txt.text;
		} else {
			return "";
		}
	}
	public set faceTextDownShiftX(val:number){
		this._faceTextDownShiftX = val;
	}
	public get faceTextDownShiftX(){
		return this._faceTextDownShiftX;
	}	
	public set faceTextDownShiftY(val:number){
		this._faceTextDownShiftY = val;
	}
	public get faceTextDownShiftY(){
		return this._faceTextDownShiftY;
	}

	public set hasRolloverText(val:boolean){
		this._hasRolloverText = val;
		if (this._hasRolloverText){
			this.stageSymbol.rollover_txt.visible = false; // Default is to hide.
		}
	}
	public get hasRolloverText(){
		return this._hasRolloverText;
	}	
	public set enableRolloverText(val:boolean){
		if (this._hasRolloverText){
			this._enableRolloverText = val;
			//this.safeStageSymbol.rollover_txt.visible = val;
		}
	}	
	public get enableRolloverText(){
		if (this._hasRolloverText){
			return this._enableRolloverText; //this.safeStageSymbol.rollover_txt.visible;
		} else {
			return false;
		}
	}	
	public set rolloverText(val:string){
		if (this._hasRolloverText){
			////this.safeStageSymbol.rollover_txt.text = val;
			this.stageSymbol.rollover_txt.text = val;
			////this.safeStageSymbol.rollover_txt.visible = false;
			this.stageSymbol.rollover_txt.visible = false;
		}
		//console.log("Now rollover_txt.text = "+this.stageSymbol.rollover_txt.text);
	}
	public get rolloverText():string{
		if (this._hasRolloverText){
			////return this.safeStageSymbol.rollover_txt.text;
			return this.stageSymbol.rollover_txt.text;
		} else {
			return "";
		}	
	}
	public set buttonEnabled(val:boolean){
		if (val != this._buttonEnabled){
			this._buttonEnabled = val;
			this.returnToUp();
		}
	}
	public get buttonEnabled():boolean{
		return this._buttonEnabled;
	}
	public get buttonIsDown():boolean{
		return this._buttonIsDown;
	}

	//-----------------------------------------------------------------------------
	// Setters and getters
}

